export default "__VITE_ASSET__zrIWKEfB__"